import {defineComponent, ref, onMounted, computed, reactive, toRefs, inject, onServerPrefetch} from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Pagination, Autoplay, Navigation} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import {getProductDetailUrl, getUnitString,setCanonicalUrl,setSeo} from "@/utils/displayUtil";
import {lbIndexController} from "@shared-core/service/LbIndexControlller";
import {useRoute} from "vue-router";
import LbIndexDto from "@shared-core/service/model/index/LbIndexDto";
import HeaderDto from "@shared-core/service/model/header/HeaderDto";
import {headerController} from "@shared-core/service/HeaderController";
import {getCategoryUrl, getProductListShowModePageUrl, getSpecialAreaPageUrl} from "@/utils/urlUtils";
import {AreaType} from "@/types/AreaType";
import BaseListProduct from "@shared-core/service/model/BaseListProduct";
import {getScreen, PhScreen} from "@/utils/media";
import {getAdminImgUrl} from "@/utils/imageUtils";
import {useContext} from "@/Ph";
import {couponController} from "@shared-core/service/CouponController";
import Coupon from "@shared-core/service/model/coupon/Coupon";
import ScrollLoading from '@/components/common/loading/ScrollLoading.vue';
import Promotion from "@/components/header/pcHeader/promoBanner/Promotion.vue";
export default defineComponent({
    components: { Swiper, SwiperSlide ,ScrollLoading,Promotion},
    setup() {
        let route=useRoute();
        const context = useContext();
        const categoryProductTabs = [
            { label: 'Top Selling', key: 'above3' ,areaType: AreaType.BestSellers },
            { label: 'New Arrivals', key: 'newArrivals',areaType: AreaType.NewArrivals},
            { label: 'On Sale', key: 'onSale',  areaType: AreaType.Promotion },
            { label: 'Under $3', key: 'under3', areaType: AreaType.FixedPriceDeals3 },
            { label: 'You May Like', key: 'youMayLike', areaType: null}
        ]
        const activeTab = ref('recommended');
        const data = reactive({
            winStyle: <any> {},
            lbIndexDto: <LbIndexDto> {},
            isShowNavCate: <boolean> false,
            init:<boolean> false,
            isShowBigSale: <boolean> false,
            isSignIn:<boolean> false,
            customerReviewStyle:<any>{},
            slideItem:0,
            categoryTree: <any> [],
            // 添加商品缓存
            productCache: <Map<string, Map<number, BaseListProduct[]>>> new Map(),
            // 添加每个类别的当前选中的tab索引
            categoryActiveTabs: <Map<number, number>> new Map(),
            holiday: <any> null,
            showHoliday:<boolean> false,
            showCouponBox:<boolean> true,
            above3Products:<Map<number, BaseListProduct[]>> null,
            currentCategoryId:<number>0,
        });
        // 倒计时逻辑
        const countdown = reactive({
            day: 0,
            hour: 0,
            minute: 0,
            second: 0
        })

        let headInfo = <HeaderDto> inject('headInfo');
        data.isSignIn = headInfo.customerId != null;
        data.isShowBigSale = headInfo.showClearance;
        data.slideItem = data.lbIndexDto.isMobile?3:6;
        onServerPrefetch(async ()=>{
            let edmCouponCodes:string  = route.query.edmCouponCodes as string | undefined;
            let isPreview:number  = Number(route.query.isPreview || route.query.preview || 0);
            data.lbIndexDto = await lbIndexController.index(edmCouponCodes,isPreview);
            context.clientData['lbIndexDto'] = data.lbIndexDto;
            setSeo(data.lbIndexDto.seo.title,data.lbIndexDto.seo.keywords,data.lbIndexDto.seo.description);
            // 添加 canonical 标签（服务端渲染）
            setCanonicalUrl(route, context);
        });
        if(context.isClient) {
            data.lbIndexDto = context.clientData['lbIndexDto'];
            setSeo(data.lbIndexDto.seo.title,data.lbIndexDto.seo.keywords,data.lbIndexDto.seo.description);
        }
        onMounted(async () => {
            data.winStyle = {'height':  window.outerHeight + 'px'}
            let isPhone = (getScreen() == PhScreen.PHONE || getScreen()==PhScreen.PHONE_SMALL);
            if(data.lbIndexDto.adsSmallBanner){
                 data.lbIndexDto.adsSmallBanner = data.lbIndexDto.adsSmallBanner.sort((a, b) => {
                    const aHasValue = a.color ? 1 : 0;
                    const bHasValue = b.color ? 1 : 0;
                    return bHasValue - aHasValue;

                }).map(
                    a=>{
                        if(isPhone && a.color){
                            a.imgUrl = a.color;
                        }
                        return a;
                    });
            }
            if(data.lbIndexDto.productReviewImg){
                updateBackground();
            }
            if(data.lbIndexDto.specialBargainsForYou && data.lbIndexDto.specialBargainsForYou.length>0){
                startCountdown();
            }
            data.categoryTree = await headerController.listHeaderCategoryTree();
            // 添加 canonical 标签（客户端）
            setCanonicalUrl(route, context);
        });

        const activeList = computed(() => {
            if (!data.lbIndexDto) return [];
            return activeTab.value == 'recommended'
                ? data.lbIndexDto.recommendedCategories || []
                : data.lbIndexDto.newArrivals || [];
        });

        function startCountdown() {
            let totalSecond = data.lbIndexDto.personPromoteEndTime;
            function update() {
                if (totalSecond <= 0) return
                countdown.day = Math.floor(totalSecond / (60 * 60 * 24))
                countdown.hour = Math.floor(totalSecond / 3600) % 24
                countdown.minute = Math.floor(totalSecond / 60) % 60
                countdown.second = totalSecond % 60
                totalSecond--
                setTimeout(update, 1000)
            }
            update();
        }

        const groupedProducts = computed(() => {
            const groups = []
            for (let i = 0; i < data.lbIndexDto.specialBargainsForYou.length; i += data.slideItem) {
                groups.push(data.lbIndexDto.specialBargainsForYou.slice(i, i + data.slideItem))
            }
            return groups
        })

        // 是否显示左右箭头
        const showNavigation = computed(() => data.lbIndexDto.specialBargainsForYou.length > data.slideItem)

        // 响应式地监听屏幕宽度变化
        const updateBackground = () => {
            if (isMobile()) {
                const bgColor = !data.lbIndexDto.productReviewImg.info1 ? '#fff' : data.lbIndexDto.productReviewImg.info1
                data.customerReviewStyle = {
                    background: `${bgColor} !important`,
                    backgroundSize: 'auto'
                }
            }else {
                data.customerReviewStyle = {
                    background: `url(${getAdminImgUrl(data.lbIndexDto.productReviewImg.img1)}) center left no-repeat #fff`,
                    backgroundSize: '100%'
                }
            }
        }


        const formatNumber = (num)=> {
            return num < 10 ? '0' + num : num
        }

        // 设定移动端宽度阈值
        const isMobile = () => {
            return window.innerWidth < 768;
        }

        const handleOpenNavCate = (flag) =>{
            data.isShowNavCate = flag
        }


        const getCategoryProducts = (categoryId: number): BaseListProduct[] => {
            // 获取当前选中的 tab 索引
            const activeTabIndex = getCategoryActiveTab(categoryId);
            // 根据索引获取对应的 key
            const activeKey = categoryProductTabs[activeTabIndex]?.key || 'above3';
            
            // 检查缓存
            const categoryCache = data.productCache.get(activeKey);
            if (categoryCache && categoryCache.has(categoryId)) {
                return categoryCache.get(categoryId) || [];
            }
            
            // 对于above3，直接从首页数据获取（已预加载）
            if (activeKey === 'above3') {
                const products = data.above3Products[categoryId] || [];
                // 缓存结果
                if (!data.productCache.has(activeKey)) {
                    data.productCache.set(activeKey, new Map());
                }
                data.productCache.get(activeKey)?.set(categoryId, products);
                return products;
            }
            
            // 其他 tab 的数据还没有加载，返回空数组
            return [];
        }

        const getCategoryActiveTabKey = (categoryId: number): string => {
            const activeTabIndex = getCategoryActiveTab(categoryId);
            return categoryProductTabs[activeTabIndex]?.key || 'above3';
        }

        const getCategoryActiveTab = (categoryId: number): number => {
            return data.categoryActiveTabs.get(categoryId) || 0;
        }

        const setCategoryActiveTab = (categoryId: number, tabIndex: number) => {
            data.categoryActiveTabs.set(categoryId, tabIndex);
        }

        const loadCategoryProducts = async (categoryId: number, key: string): Promise<BaseListProduct[]> => {
            // 检查缓存
            const categoryCache = data.productCache.get(key);
            if (categoryCache && categoryCache.has(categoryId)) {
                return categoryCache.get(categoryId) || [];
            }
            try {
                // 调用API加载数据
                const response = await lbIndexController.getCategoryProducts(categoryId, key);
                const products = response || [];

                // 缓存结果
                if (!data.productCache.has(key)) {
                    data.productCache.set(key, new Map());
                }
                data.productCache.get(key)?.set(categoryId, products);

                return products;
            } catch (error) {
                console.error('Failed to load category products:', error);
                return [];
            }
        }

        const headHandleTabClick = (categoryId: number) => {
            // 切换 tab 状态
            data.currentCategoryId = categoryId;
        }

        const handleTabClick = async (categoryId: number, key: string, tabIndex: number) => {
            // 先切换 tab 状态
            setCategoryActiveTab(categoryId, tabIndex);

            // 如果是above3，直接返回（已预加载）
            if (key === 'above3') {
                return;
            }

            // 检查是否已加载
            const categoryCache = data.productCache.get(key);
            if (categoryCache && categoryCache.has(categoryId)) {
                // 已加载，直接返回
                return;
            }

            // 异步加载数据
            await loadCategoryProducts(categoryId, key);
        }

        const onSwiper = (swiper) => {};
        const onSlideChange = () => {};


        const toggleHeadline = async () => {
            if(!data.holiday){
                data.holiday = await headerController.holidayAndCollections(0);
            }
            data.showHoliday = !data.showHoliday;
        }
        
        const getCoupon = async (c:Coupon) => {
            try {
                if(!c.isClicked){
                    await couponController.bindCoupon(c.facebookCode);
                    c.isClicked = true;
                }
            }catch (e){
               console.log("getCoupon error:"+c.facebookCode);
            }

        }

        const closeCouponBox = () => {
          data.showCouponBox = false;
        }

        const loadAbove3 = async () =>{
            // 加载Above3
            try {
               data.above3Products =  await lbIndexController.loadAbove3();
            } catch (error) {
                console.error('Failed to load Above3:', error);
            }finally {

            }
        }

        const onScrollLoading = async (callback: () => void) => {
            try {
                await loadAbove3();
            } finally {
                callback();
            }
        }

        return {
            ...toRefs(data),
            modules: [Pagination, Autoplay, Navigation],
            onSwiper,
            onSlideChange,
            breakpoints: {
                375: {
                    slidesPerView: 3.5,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 3.5,
                    spaceBetween: 0,
                },
            },
            countdown,
            handleOpenNavCate,
            showNavigation,
            groupedProducts,
            getProductDetailUrl,
            getUnitString,
            formatNumber,
            categoryProductTabs,
            getCategoryProducts,
            loadCategoryProducts,
            headHandleTabClick,
            handleTabClick,
            getCategoryActiveTab,
            getCategoryActiveTabKey,
            setCategoryActiveTab,
            getCategoryUrl,
            getProductListShowModePageUrl,
            getSpecialAreaPageUrl,
            getAdminImgUrl,
            activeList,
            activeTab,
            toggleHeadline,
            getCoupon,
            closeCouponBox,
            onScrollLoading,
        };
    }
});